export default __webpack_public_path__ + "static/media/28.f7952d63.jpg";